module.exports = __webpack_public_path__ + "static/media/arrow-right-copy.a5f6a8af.svg";